export const STRIPE_ERROR_CODES_TO_ADDITIONAL_DETAILS = {
    consent_declined: "You declined to be verified. Please try again if you wish to continue.",
    under_supported_age: "We can only verify users who are of legal age. Please contact support for assistance.",
    country_not_supported: "Unfortunately, we don't currently support verification for your country.",

    document_expired: "The ID document you provided has expired. Please submit a valid, non-expired document.",
    document_unverified_other: "We couldn't verify your ID document. Please ensure your document is authentic, clearly visible, and all details are legible.",
    document_type_not_supported: "The type of ID document you provided isn't supported. Please use a passport, driver's license, or national ID card.",

    selfie_document_missing_photo: "Your ID document doesn't contain a visible photo. Please submit a document with a clear photo.",
    selfie_face_mismatch: "We couldn't confirm your selfie matches the photo on your ID document. Please try again with better lighting.",
    selfie_unverified_other: "There was an issue verifying your selfie. Please ensure your face is clearly visible and well-lit.",
    selfie_manipulated: "The selfie appears to be altered or manipulated. Please submit an original selfie.",

    id_number_unverified_other: "We couldn't verify your identification number. Please check it's entered correctly.",
    id_number_insufficient_document_data: "Your document doesn't contain enough information to verify your ID number.",
    id_number_mismatch: "The ID number information couldn't be verified against our records.",

    address_mismatch: "The address information couldn't be verified against our records.",
}
